import './styles.scss';
import { registerFragment } from '../../registry';
import { DisposalSet } from '../../../utils';
const gc = new DisposalSet();
registerFragment('aoc-1-3-layout', (fragEl, config, meta) => {});
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
  import.meta.webpackHot.dispose(() => gc.disposeAll());
}